import {
    PromoWrapper,
    syncReactUIConfigurationStore,
    syncReactUINavigationStore,
    syncReactUISessionStore,
} from '@amusnet/react-ui'
import useGetBetAmount from '@hooks/useGetBetAmount'
import { useConfigurationStore } from '@stores/configurationStore'
import { useLuckySpinsStore } from '@stores/luckySpinsStore'
import { useNavigationStore } from '@stores/navigationStore'
import { usePlayerInfoStore } from '@stores/playerInfoStore'
import React, { useEffect, useMemo } from 'react'

interface PromoProps {
    stageScale: number
    setShouldPromoMoveToTopLayer: (shouldPromoMoveToTopLayer: boolean) => void
}

const usePromoWidgetConfig = () => {
    const hasBuyBonus = useConfigurationStore((state) => state.hasBuyBonus)
    const componentName = hasBuyBonus ? 'PromoWidget' : 'BuyBonusButton'

    const styles = useConfigurationStore((s) => s.getComponentConfig(componentName).styles)
    const dimensions = useConfigurationStore((s) => s.getComponentConfig(componentName).dimensions)
    const position = useConfigurationStore((s) => s.getComponentConfig(componentName).position)

    return useMemo(() => ({ styles, dimensions, position }), [styles, dimensions, position])
}

const Promo: React.FC<PromoProps> = ({ stageScale, setShouldPromoMoveToTopLayer }) => {
    const isGameLoaded = useConfigurationStore((state) => state.isGameLoaded)
    const configurationStoreState = {
        viewport: useConfigurationStore((state) => state.viewport),
        stageDimensions: useConfigurationStore((state) => state.stageDimensions),
        currency: useConfigurationStore((state) => state.currency),
        currencyHideCents: useConfigurationStore((state) => state.currencyHideCents),
        playerName: useConfigurationStore((state) => state.playerName),
        playerUid: useConfigurationStore((state) => state.playerUid),
        authToken: useConfigurationStore((state) => state.token),
        isSoundMuted: useConfigurationStore((state) => state.isSoundMuted),
        apiBaseUrl: useConfigurationStore((state) => state.apiBaseUrl),
        language: useConfigurationStore((state) => state.language),
    }

    useEffect(() => {
        syncReactUIConfigurationStore(configurationStoreState)
    }, [configurationStoreState])

    const betAmount = useGetBetAmount()
    const balance = usePlayerInfoStore((state) => state.balance)
    const updateBalance = usePlayerInfoStore((state) => state.updateBalance)

    useEffect(() => {
        syncReactUISessionStore({ betAmount, balance })
    }, [betAmount, balance])

    const isHomeDisabled = useNavigationStore((state) => state.isHomeDisabled)

    useEffect(() => {
        syncReactUINavigationStore({ isHomeDisabled })
    }, [isHomeDisabled])

    const isLSAvailableInGame = useConfigurationStore((state) => state.hasLuckySpins)
    const isCurrentlyConsumingLS = useLuckySpinsStore((state) => state.showRemainingSpinsBanner)

    const widgetComponentConfig = usePromoWidgetConfig()

    return (
        <PromoWrapper
            stageScale={stageScale}
            widgetComponentConfig={{
                styles: {
                    position: 'absolute',
                    ...widgetComponentConfig.position,
                    ...widgetComponentConfig.dimensions,
                },
                classNames: widgetComponentConfig.styles,
            }}
            isGameLoaded={isGameLoaded}
            isLSAvailableInGame={isLSAvailableInGame}
            isCurrentlyConsumingLS={isCurrentlyConsumingLS}
            updateBalance={updateBalance}
            setShouldPromoMoveToTopLayer={setShouldPromoMoveToTopLayer}
        />
    )
}

export default Promo
